module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.getCurrentRT.is_sandbox) ? _c('div', [_c('div', {
    staticClass: "dot-container row middle-xs center-xs",
    on: {
      "click": function($event) {
        _vm.show_modal = true
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-info info-icon dtc v-mid"
  }), _vm._v(" "), _c('div', {
    staticClass: "interactive-demo-dot dt"
  })]), _vm._v(" "), (_vm.show_modal) ? _c('pl-dialog', {
    attrs: {
      "maxHeight": "80%",
      "minWidth": "600px",
      "disableOutsideClick": true
    },
    on: {
      "close": function($event) {
        _vm.show_modal = false
      }
    }
  }, [_c('div', {
    staticClass: "h-100"
  }, [_c(_vm.componentName, {
    tag: "component",
    on: {
      "close": function($event) {
        _vm.show_modal = false
      }
    }
  })], 1)]) : _vm._e()], 1) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-4e4481e8!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/features/onlineWalkthrough/onlineWalkthroughDot.vue
// module id = 1342
// module chunks = 61